module.exports = __webpack_public_path__ + "img/kateatfarm.1802644b.jpg";